import { render, staticRenderFns } from "./WholeProcessHealth.vue?vue&type=template&id=bc8a2ee6&"
import script from "./WholeProcessHealth.vue?vue&type=script&lang=js&"
export * from "./WholeProcessHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports